import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO](context, criarTermoDesentranhamentoInput) {
		const { idDocumento, idAditivoApostila } = criarTermoDesentranhamentoInput
		const { data } = await api.desentranhamentoDocumentoAta.criarTermoDesentranhamento(
			idDocumento,
			idAditivoApostila,
		)
		return data
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.JUNTAR_TERMO](context, idDocumento) {
		const { data } = await api.desentranhamentoDocumentoAta.juntarTermoDesentranhamento(idDocumento)
		return data
	},
}
